<template>
  <div>
    <informasi-lainnya-desktop-detail v-if="!isMobile" />
    <informasi-lainnya-mobile-detail v-else />
  </div>
</template>
<script>
import InformasiLainnyaDesktopDetail from "./Desktop/InformasiLainnyaDetail-Desktop.vue";
import InformasiLainnyaMobileDetail from "./Mobile/InformasiLainnyaDetail-Mobile.vue";
export default {
  components: {
    InformasiLainnyaDesktopDetail,
    InformasiLainnyaMobileDetail,
  },
  computed: {
    isMobile() {
      if (window.innerWidth >= 500) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped>
.Hero {
  width: 100%;
  margin-top: -80px;
  object-fit: contain;
}
.Hero-Text {
  width: 763px;
  height: 56px;
  margin: 101px 418px 0 419px;
  font-family: Sora;
  font-size: 48px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
  position: absolute;
}
</style>
